namespace $ {
	/** Small metadata index; payloads and entries have independent areas. */
	export class $shm_hitalama_components_versions_store extends $giper_baza_entity.with({
		Owner: $giper_baza_atom_text,
		Entries: $giper_baza_list_link.to( ()=> $shm_hitalama_components_versions_entry ),
	}) {}
}
